/** Pause menu labels. Commands are applied by the host; opening a submenu stays on this screen. */
import { PowerupType } from '../sim/player.ts';

export interface PauseEntry {
  label: string;
  /** sent to the simulation */
  cmd?: string;
  n?: number;
  /** open another page of this menu */
  menu?: string;
  /** return to the previous page */
  back?: boolean;
}

export function pauseRoot(debug: boolean): string {
  return debug ? 'debug' : 'play';
}

export function pauseEntries(menu: string, invuln: boolean): PauseEntry[] {
  if (menu === 'play') {
    return [
      { label: 'Play', cmd: 'resume' },
      { label: 'Restart', menu: 'confirm', cmd: 'restart' },
      { label: 'Drop Out', menu: 'confirm', cmd: 'dropout' },
      { label: 'Menu', menu: 'confirm', cmd: 'exit' },
    ];
  }
  if (menu === 'debug') {
    return [
      { label: 'Play', cmd: 'resume' },
      { label: 'Give Powerup', menu: 'powerup' },
      { label: 'Debug', menu: 'tools' },
      { label: 'Disconnect All', menu: 'confirm', cmd: 'boot' },
    ];
  }
  if (menu === 'powerup') {
    return [
      { label: 'Back', back: true },
      { label: 'Block Dude', cmd: 'powerup', n: PowerupType.BlockDude },
      { label: 'Double Dash', cmd: 'powerup', n: PowerupType.DoubleDash },
      { label: 'Big Dude', cmd: 'powerup', n: PowerupType.BigDude },
      { label: 'Jetpack', cmd: 'powerup', n: PowerupType.Jetpack },
    ];
  }
  if (menu === 'tools') {
    return [
      { label: 'Back', back: true },
      { label: 'Speed', menu: 'speed' },
      { label: invuln ? 'Let me die again' : 'I dont wanna die', cmd: 'invuln' },
      { label: 'Cut String', cmd: 'cut' },
    ];
  }
  if (menu === 'speed') {
    return [
      { label: 'Back', back: true },
      { label: '.25x', cmd: 'speed', n: 0.25 },
      { label: '.5x', cmd: 'speed', n: 0.5 },
      { label: '1x', cmd: 'speed', n: 1 },
      { label: '2x', cmd: 'speed', n: 2 },
    ];
  }
  return [
    { label: 'Yes', cmd: 'yes' },
    { label: 'No', back: true },
  ];
}

export function pauseTitle(menu: string, pending: string | null): string {
  if (menu === 'confirm') {
    if (pending === 'restart') return 'Restart level?';
    if (pending === 'dropout') return 'Drop out?';
    if (pending === 'exit') return 'Quit to menu?';
    if (pending === 'boot') return 'Disconnect all players?';
    return 'Are you sure?';
  }
  if (menu === 'powerup') return 'Give Powerup';
  if (menu === 'tools') return 'Debug';
  if (menu === 'speed') return 'Speed';
  if (menu === 'debug') return 'Paused';
  return 'Paused';
}
